import { DebugGA } from 'game/CustomConsole';
import { Store } from 'game/store/gameStore';

export function GAEvent(event: GAEventNames | string, data: { [key: string]: number | string }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event, // The name of the event you want to track
        name: Store.name,
        ...data, // Event data or parameters
    });
    DebugGA(event + '" => ' + JSON.stringify(data));
}
export enum GAEventNames {
    GAME_START = 'game_start',
    GAME_WIN = 'game_win',
    GAME_RESTART = 'game_restart',
    GAME_UNDO = 'game_undo',
    GAME_RULES_OPEN = 'game_rules_opened',
    GAME_SETTINGS_OPEN = 'game_settings_opened',
    GAME_DESIGN_OPEN = 'game_design_opened',

    GAME_SETTINGS_SOUNDS = 'game_settings_sounds',
    GAME_SETTINGS_HAND = 'game_settings_hand',
    GAME_SETTINGS_AUTOCOMPLETE = 'game_settings_autocomplete',
    GAME_DESIGN_FRONT = 'game_design_front',
    GAME_DESIGN_BACK = 'game_design_back',
    GAME_DESIGN_BACKGROUND = 'game_design_background',
    OPEN_NEW_GAME_POPUP = 'game_new_game_popup_opened',
    NEW_GAME_CLICK = 'game_new_game_play',
    WIN_POPUP_NEW_GAME_CLICK = 'game_win_popup_play',
    GAME_SETTINGS_HIGHLIGHT = 'game_settings_highlighting',
    GAME_SETTINGS_AUTOPLAY = 'game_settings_autoplay',

    FACEBOOK_BANNER_VIEW = 'facebook_banner_view',
    FACEBOOK_BANNER_CLOSE = 'facebook_banner_close',
    FACEBOOK_BANNER_FOLLOW = 'facebook_banner_follow',
    SHOW_SHARE = 'share_menu_click',
    SHARE_SUCCESSFUL = 'share_successful',
    HINT_CLICK = 'game_hint',

    SHOW_NO_HINT_MODAL = 'game_no_hints_popup',
    NO_HINT_NEW_GAME = 'game_no_hints_popup_new_game',
    NO_HINT_RESTART_GAME = 'game_no_hints_popup_restart',
    NO_KEEP_PLAY = 'game_no_hints_popup_keep_playing',

    ADS_BREAK_POPUP = 'ad_break_preview', //counter
    ADS_BREAK_START = 'ad_break_start', // ad shown
    ADS_BREAK_DONE = 'ad_break_done',

    ADS_REWARDER_CLICK = 'ad_rewarded_click',
    ADS_REWARDER_SKIP = 'ad_rewarded_skip',
    ADS_REWARDER_RECEIVE = 'ad_rewarded_receive',
    ADS_REWARDER_ERROR = 'ad_rewarded_receive_ad_not_filled',

    MAGIC_WAND_CLICK = 'game_mw',
    MAGIC_WAND_ONBOARDING = 'game_mw_onboarding',
    MAGIC_WAND_ONBOARDING_TRY = 'game_mw_onboarding_try',

    MAGIC_WAND_ONBOARDING_CLOSE = 'game_mw_onboarding_close',
    MAGIC_WAND_NO_MOVES = 'game_no_mw_popup',

    MAGIC_WAND_NO_MOVES_CLOSE = 'game_no_mw_popup_close',
    MAGIC_WAND_NO_MOVES_CONFIRM = 'game_no_mw_popup_watch_ad',
    MAGIC_WAND_NO_NEEDED = 'game_mw_no_needed',

    OUT_MOVE_WAND_POPUP = 'game_no_hints_mw_popup',
    OUT_MOVE_WAND_POPUP_CLOSE = 'game_no_hints_mw_popup_close',
    OUT_MOVE_WAND_POPUP_CONFIRM = 'game_no_hints_mw_popup_use',

    OUT_MOVE_AD_POPUP = 'game_no_hints_no_mw_popup',
    OUT_MOVE_AD_CLOSE = 'game_no_hints_no_mw_popup_close',
    OUT_MOVE_AD_CONFIRM = 'game_no_hints_no_mw_popup_watch_ad',

    FEEDBACK_SHOW = 'feedback_banner',
    FEEDBACK_NOT_NOW = 'feedback_banner_not_now',
    FEEDBACK_SEND = 'feedback_banner_send',
    FEEDBACK_ERROR = 'feedback_banner_failed',
    AD_BLOCKER_POPUP_SHOW = 'ad_adblocker_popup',
    AD_BLOCKER_POPUP_CLOSE = 'ad_adblocker_popup_close',
    NOTIFICATION_POPUP_SHOW = 'push_notifications_view',
    NOTIFICATION_POPUP_SUBSCRIBE = 'push_notifications_subscribe',
    NOTIFICATION_POPUP_SKIP = 'push_notifications_not_now',
    STORIES_OPEN = 'stories_win_popup_button',

    STORIES_USE_TICKET_BANNER_CLOSE = 'stories_use_ticket_banner_close',
    STORIES_USE_TICKET_BANNER_OPEN = 'stories_use_ticket_banner_open',
    STORIES_USE_TICKET_BANNER_VIEW = 'stories_use_ticket_banner_view',
}
